import React from "react";
import SettingsHeader from "../../components/Profile/SettingsHeader";
import { GLOBAL_IMAGES } from "../asset";
import AboutContent from "../../components/about/AboutContent";
import useIndiaLocation from "../../hooks/useIndiaLocation";

const About = () => {
  const isIndiaLocation = useIndiaLocation();

  return (
    <div
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="settings-page min-h-screen flex flex-col bg-blue-50 font-mali"
    >
      <SettingsHeader name="About Us" oneBack="true" />
      {isIndiaLocation ? (
        <div className="mx-auto my-20 w-[60%] rounded-lg bg-white/60 p-10">
          <h1 className="mb-6 text-4xl font-bold text-black">
            About MathDingo
          </h1>
          <div className="space-y-6 text-lg leading-8 text-gray-700">
            <p>
              We started MathDingo in 2013 to make math education more
              accessible. We also believe that math education should be fun and
              engaging, so we've designed our app with a user-friendly interface
              and gamified elements to keep students motivated.
            </p>
            <p>
              At MathDingo, we believe that everyone deserves access to quality
              math education, regardless of their background or circumstances.
              That's why we've created a math app that is designed to be
              accessible, affordable, and engaging for everyone.
            </p>
            <p>
              Our app offers a comprehensive math curriculum that covers all the
              essential topics from elementary school through high school. We
              also offer a variety of learning tools and resources, such as
              video lessons, practice exercises, and personalized feedback.
            </p>
            <p>
              We are committed to making math education more accessible by
              offering our app for free. We also believe that math education
              should be fun and engaging, so we've designed our app with a
              user-friendly interface and gamified elements to keep students
              motivated.
            </p>
            <p>
              We are passionate about helping students succeed in math, and we
              believe that our app can make a real difference in their lives. We
              are constantly working to improve our app and add new features,
              and we are always looking for ways to make math education more
              accessible to everyone.
            </p>
            <p>
              If you are looking for a way to improve your math skills, we
              encourage you to try MathDingo. We believe that our app can help
              you achieve your math goals and reach your full potential.
            </p>
          </div>
        </div>
      ) : (
        <AboutContent />
      )}
    </div>
  );
};

export default About;
